// Articles created without a real source webpage (blank start, pasted text, AI
// script) carry a placeholder url. Historically it was written with two different
// hosts (cdn.lumen5.com in settings, storage.googleapis.com hardcoded in
// article/models.py), so match on the path rather than the exact configured value.
const PLACEHOLDER_ARTICLE_PATH = '/lumen5-site-css/start_from_nothing.html';

export function isPlaceholderArticleUrl(url: string): boolean {
    return url === SERVER.EMPTY_ARTICLE_URL || url.endsWith(PLACEHOLDER_ARTICLE_PATH);
}
